import { MailTemplateResource, mailTemplateResource } from '@witkac/kartamiejska-resources';
import { MailTemplateObjectType } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł listy szablonów mailowych
 *
 * @export
 * @class mailTemplatesModule
 * @extends {EntityModule<MailTemplateObjectType, MailTemplateResource>}
 */
export class MailTemplatesModule extends EntityModule<MailTemplateObjectType, MailTemplateResource> {
  constructor() {
    super(mailTemplateResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje szablon
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any) => {
        data.mailTemplate.id = await this.resource.add(data);
        context.commit('add', data.mailTemplate);
        context.commit('incrementCount');
      },
      /**
       * Aktualizuje szablon
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: any) => {
        data.mailTemplate.id = await this.resource.update(data.id, data);
        context.commit('update', data.mailTemplate);
        context.commit('setEntity', data.mailTemplate);
      }
    };
  }
}

export default new MailTemplatesModule();
